module.exports = __webpack_public_path__ + "static/img/test_icon.2fc77296.png";